<template>
    <div class="GameReport">
        <header class="header">
            <div class="item" style="display: flex;align-items: center;">
                <el-avatar :size="80" :src="circleUrl"></el-avatar>
                <span class="Gametype">{{trainreport.TrainCatalog}}</span>
            </div>
            <div class="item">
                <p class="gameName">{{trainreport.TrainName}}</p>
                <p class="gametip">仅供本次认知训练结果参考</p>
            </div>
            <div class="item">
                <p class="gametime">测试用时：{{Math.floor(trainreport.Result.totalTime/1000)}}s</p>
            </div>
        </header>
        <main>
            <div class="userinfo">
                <p class="userinfotitle">
                    <span>人员基本信息</span>
                </p>
                <div class="content">
                    <div class="left">
                        <div class="left_name">
                            <p>账号</p>
                            <p>姓名</p>
                            <p>性别</p>
                            <p>年龄</p>
                        </div>
                        <div class="left_con">
                            <p>{{trainreport.UserInfo.UserID}}</p>
                            <p>{{trainreport.UserInfo.NickName}}</p>
                            <p>{{trainreport.UserInfo.Sex==0?'女':'男'}}</p>
                            <p>{{trainreport.UserInfo.NickName}}无</p>
                        </div>
                    </div>
                    <div class="right">
                        <div class="right_name">
                            <p>机构</p>
                            <p>教育程度</p>
                            <p>户口</p>
                            <p>测试日期</p>
                        </div>
                        <div class="right_con">
                            <p>{{trainreport.UserInfo.DeptIDName==''?'-':trainreport.UserInfo.DeptIDName}}</p>
                            <p>{{trainreport.UserInfo.Degree==''?'-':trainreport.UserInfo.Degree}}</p>
                            <p>{{trainreport.UserInfo.Address==''?'-':trainreport.UserInfo.Address}}</p>
                            <p>{{trainreport.Result.endTime==''?'-':trainreport.Result.endTime}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="testresult">
                <p class="userinfotitle">
                    <span>测试结果</span>
                </p>
                <table class="gametable" padding="0" >
                    <tr>
                        <th>正确个数</th>
                        <th>正确率</th>
                        <th>错误个数</th>
                        <th>错误率</th>
                        <th>测试总时长</th>
                        <th>上次用时</th>
                        <th>本次得分</th>
                        <th>上次得分</th> 
                        <th>最好成绩</th>
                        <th>排行名次</th>
                    </tr>
                    <tr>
                        <td>{{trainreport.Result.rightQty}}</td>
                        <td>{{trainreport.Result.rightRate}}%</td>
                        <td>{{trainreport.Result.faultQty}}</td>
                        <td>{{trainreport.Result.faultRate}}%</td>
                        <td>{{trainreport.Result.totalTime}}/ms</td>
                        <td>{{trainreport.LastDuration}}/ms</td>
                        <td>{{trainreport.LastResult}}</td>
                        <td>{{trainreport.LastResult}}</td>
                        <td>{{trainreport.BestResult}}</td>
                        <td>{{trainreport.Rank}}</td>
                    </tr>
                    
                </table>
                <div class="result_text">结果解释：{{trainreport.Explain}}</div>
                <div class="result_text">名词解释：{{trainreport.Definition}}</div>
                <div class="result_text">日常建议：{{trainreport.Advice}}</div>
                <div class="result_text">推荐方案: {{trainreport.Solution}}</div>
            </div>

            <!-- 具体反应 -->
            <div class="Specificreactions">
                <p class="userinfotitle">
                    <span>具体反应</span>
                </p>
                <table class="gametable" padding="0" >
                    <tr>
                        <th>序号</th>
                        <th>难度</th>
                        <th>正确答案</th>
                        <th>提交答案</th>
                        <th>反应时(ms)</th>
                        <th>反应结果</th>
                    </tr>
                    <tr v-for="item in trainreport.ResultDetails" :key="item.resultDetailKey">
                        <td>{{item.lineNumber}}</td>
                        <td>{{item.diffType==1?'新手':item.diffType==2?'标准':'困难'}}</td>
                        <td>{{ item.correctItem}}</td>
                        <td>{{ item.subResult}}</td>
                        <td>{{item.rageTime}}</td>
                        <td>{{item.rindex==1?'正确':item.rindex==2?'错误':'遗漏'}}</td>
                    </tr>
                </table>
            </div>

        </main>
    </div>
</template>
<script>
    export default{
        data() {
            return {
                circleUrl:'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
                resultKey:38,
                trainreport:''
            }
        },
        created(){
            this.init()
        },
        methods: {
            init(){
                this.$Http_Post('/management/game/gettrainreport',{resultKey:this.resultKey}).then(res=>{
                    if(res.Code==0 || res.Code==200){
                        this.trainreport=res.Data;
                        console.log(res.Data);
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }
        },
    }
</script>
<style scoped>
.GameReport{background:#B8D2FF;padding-bottom: 30px;width: 1280px;margin: auto;}
.GameReport .header{background: #4E7EC2;padding: 30px;display: flex;justify-content: space-between;align-items: center;}
.GameReport .header .Gametype{font-size: 30px;color: #fff;padding-left: 30px;}
.GameReport .header .gameName{font-size: 24px;color: #fff;text-align: center;}
.GameReport .header .gametip{font-size: 18px;color: #C9C9C9;text-align: center;}
.GameReport .header .gametime{font-size: 20px;color: #FFB04F;}
.GameReport main .userinfo{background: #fff;margin: 40px 30px 0 30px;padding-bottom: 40px;border-radius: 8px;}
.GameReport main .userinfo .userinfotitle{text-align: center;position: relative;}
.GameReport main .userinfo .userinfotitle span{position: absolute;top: 0;left: 0;right: 0;font-size: 28px;color: #fff;line-height: 60px;}
.GameReport main .userinfo .userinfotitle::before{content:'';width:278px;border-top:60px solid #4E7EC2;border-left: 30px solid transparent;border-right: 30px solid transparent;display: inline-block;}
.GameReport main .userinfo .content{display: flex;font-size: 24px;margin-top: 40px;justify-content: space-between;margin:40px 20px;}
.GameReport main .userinfo .content .left,.GameReport main .userinfo .content .right{display: flex;}
.GameReport main .userinfo .content .left .left_name,.GameReport main .userinfo .content .right .right_name{padding:0 0 20px;;width:96px;text-align: right;margin:0 20px 0 0;}
.GameReport main .userinfo .content .left .left_con,.GameReport main .userinfo .content .right .right_con{background: #EDF6FF;padding:0 20px 0;width: 390px;border-radius: 8px;}
.GameReport main .userinfo .content .left p,.GameReport main .userinfo .content .right p{padding: 30px 0 0;}

.GameReport main .testresult{background: #fff;margin: 40px 30px 0 30px;padding-bottom: 30px;border-radius: 8px;}
.GameReport main .testresult .userinfotitle{text-align: center;position: relative;padding-bottom: 40px;}
.GameReport main .testresult .userinfotitle span{position: absolute;top: 0;left: 0;right: 0;font-size: 28px;color: #fff;line-height: 60px;}
.GameReport main .testresult .userinfotitle::before{content:'';width:278px;border-top:60px solid #4E7EC2;border-left: 30px solid transparent;border-right: 30px solid transparent;display: inline-block;}
.GameReport main .testresult .gametable{width:calc(100% - 40px);font-size:16px;border-collapse: collapse;margin: 0 25px 20px;}
.GameReport main .testresult .gametable tr{display: flex;border-bottom:1px solid #4C76A1;}
.GameReport main .testresult .gametable th{background: #EDF6FF;padding: 20px 0;flex: 1;}
.GameReport main .testresult .gametable tr td{text-align: center;border-right:1px solid #4C76A1;padding: 20px 0;color: #4C76A1;flex: 1;}
.GameReport main .testresult .gametable tr td:first-child{border-left:1px solid #4C76A1;}
.GameReport main .testresult .result_text{padding: 10px 30px;font-size: 20px;}

.GameReport main .Specificreactions{background: #fff;margin: 40px 30px 0 30px;padding-bottom: 40px;border-radius: 8px;}
.GameReport main .Specificreactions .userinfotitle{text-align: center;position: relative;}
.GameReport main .Specificreactions .userinfotitle span{position: absolute;top: 0;left: 0;right: 0;font-size: 28px;color: #fff;line-height: 60px;}
.GameReport main .Specificreactions .userinfotitle::before{content:'';width:278px;border-top:60px solid #4E7EC2;border-left: 30px solid transparent;border-right: 30px solid transparent;display: inline-block;}
.GameReport main .Specificreactions .gametable{width:calc(100% - 40px);font-size:20px;border-collapse: collapse;margin: 40px 25px 0;}
.GameReport main .Specificreactions .gametable th{background: #EDF6FF;padding: 20px 0;width: 16.6%;}
.GameReport main .Specificreactions .gametable tr td{text-align: center;width:16.6%;border:1px solid #4C76A1;padding: 20px 0;color: #4C76A1;}
</style>